import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import { SettingsAPI, MAKES as DEFAULT_MAKES, PART_CATEGORIES as DEFAULT_CATEGORIES } from '../mock';

const SettingsContext = createContext({ settings: null, loading: true, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const s = await SettingsAPI.publicSettings();
      setSettings(s);
    } catch {
      setSettings({ public_site_published: false, publish_inventory: true, publish_parts: true, publish_notices: true });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSiteSettings = () => useContext(SettingsContext);

// Convenience hooks that fall back to the static defaults from mock.js
// so the UI never breaks while settings are loading or empty.
export function useMakes() {
  const { settings } = useSiteSettings();
  return useMemo(() => {
    const list = settings?.vehicle_makes;
    return (list && list.length > 0) ? list : DEFAULT_MAKES;
  }, [settings]);
}

export function usePartCategories() {
  const { settings } = useSiteSettings();
  return useMemo(() => {
    const list = settings?.part_categories;
    return (list && list.length > 0) ? list : DEFAULT_CATEGORIES;
  }, [settings]);
}
